<truelearn-web-skip-to-main-content-link [fragmentId]="skipToMainFragment$ | async" />
<section
    [class.tl-main-with-banner]="showEnvironmentBanner"
    [class.tl-main-with-mimic-banner]="isMimic$ | async"
    class="tl-main"
>
    @if (showEnvironmentBanner) {
        <section role="banner" class="environment-banner {{ env }} banner d-flex justify-content-center p-2">
            <small class="align-self-center me-1">You are currently logged into:</small>
            <span class="env-name text-capitalize">{{ env }}</span>
        </section>
    }

    @if (isMimic$ | async) {
        <section role="banner" class="environment-banner mimic banner d-flex justify-content-center p-2">
            <small class="align-self-center">You are currently logged in under the Mimic Mode</small>
        </section>
    }

    <section
        class="d-flex flex-column h-100"
        [class.has-banner]="showEnvironmentBanner"
        [class.has-mimic-banner]="isMimic$ | async"
    >
        <div class="d-flex flex-grow-1">
            @switch (showMainContent$ | async) {
                @case ('main') {
                    <app-primary-sidebar
                        #primaryCollapsible="CollapseDirective"
                        appCollapse
                        (collapseClicked)="primaryCollapsible.toggle()"
                        [hideNavLinks]="isIE"
                        class="primary-sidebar d-none d-lg-flex ps-0 pb-5"
                    ></app-primary-sidebar>
                    <app-secondary-sidebar *ngIf="!isIE"></app-secondary-sidebar>
                    <main [attr.id]="mainContentId" class="main-content w-100 bg-white pb-5">
                        <ng-container *ngIf="!isIE">
                            <app-header></app-header>
                            <router-outlet></router-outlet>
                        </ng-container>
                        <ng-container *ngIf="isIE">
                            <div class="p-5">
                                <h1>Unsupported Browser</h1>
                                <p class="pt-2">
                                    Please note that the new faculty portal does not support Internet Explorer.
                                </p>
                                <p>
                                    To use the new portal, you will need to upgrade to the latest
                                    <a href="https://www.google.com/chrome/" target="_blank">Google Chrome</a>
                                    ,
                                    <a href="https://www.microsoft.com/en-us/edge" target="_blank">Microsoft Edge</a>
                                    , or
                                    <a href="https://www.mozilla.org/en-US/firefox/new/" target="_blank">Firefox</a>
                                    .
                                </p>
                            </div>
                        </ng-container>
                    </main>
                }

                @case ('fullscreen') {
                    <main [attr.id]="mainContentId" class="main-fullscreen-content w-100 bg-white">
                        <router-outlet class="mt-5" name="fullscreen"></router-outlet>
                    </main>
                }

                @case ('question viewer') {
                    <div [attr.id]="mainContentId" class="main-fullscreen-content w-100 bg-white">
                        <router-outlet class="mt-5" name="fullscreen"></router-outlet>
                    </div>
                }
            }
        </div>
    </section>
    <app-footer></app-footer>
    <truelearn-web-toast-messages [queueSize]="toastQueueSize"></truelearn-web-toast-messages>
</section>
